import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import View from './view';
import PerformanceUtils from "services/PerformanceUtils";
import DocumentUtils from "services/DocumentUtils";
import {useAppSelector} from "careand-redux/store";
import {InternOf} from "careand-redux/selectors";

const DEFAULT_OBJECT = {};

const CPPDocumentsInput = props => {

  const patientId = props.patient.id;

  const patientHealthRecords = useAppSelector(state => state.healthRecords.byId[patientId]) || DEFAULT_OBJECT;
  const isIntern = !!useAppSelector(InternOf);

  const [addingDocument, setAddingDocument] = useState(undefined);
  const [selected, setSelected] = useState('all');

  function selectDocumentType(selectedType) {
    setSelected(selectedType);
  }

  const documents = useMemo(() => {
    return PerformanceUtils.sortBy(
      filter(patientHealthRecords.documents, selected)
    )
  }, [patientHealthRecords.documents, selected])

  return (
    <View
      patient={props.patient}
      selectDocumentType={selectDocumentType}
      setAddingDocument={setAddingDocument}
      addingDocument={addingDocument}
      selected={selected}
      documents={documents}
      prescriptions={patientHealthRecords.prescriptions}
      onClose={props.onClose}
      disableEdit={isIntern || false}
    />
  );
};

function filter(documents = [], selected) {
  switch (selected) {
    case 'all':
      return documents;
    default:
      return DocumentUtils.filter(
        documents,
        DocumentUtils.DOCUMENT_TYPE[selected]
      );
  }
}

CPPDocumentsInput.propTypes = {
  patient: PropTypes.object.isRequired,
  bubble: PropTypes.object,
  form: PropTypes.string,
  onClose: PropTypes.func
};

export default CPPDocumentsInput
